/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ForgotPasswordRequest } from '../models/ForgotPasswordRequest';
import type { ForgotPasswordResponse } from '../models/ForgotPasswordResponse';
import type { LoginRequest } from '../models/LoginRequest';
import type { MyAccountResponse } from '../models/MyAccountResponse';
import type { ResetPasswordRequest } from '../models/ResetPasswordRequest';
import type { ResetPasswordResponse } from '../models/ResetPasswordResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthControllerService {
    /**
     * @returns any Return value of AuthController.googleCallback
     * @throws ApiError
     */
    public static authControllerGoogleCallback(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/auth/google/callback',
        });
    }
    /**
     * @returns any Return value of AuthController.googleAuth
     * @throws ApiError
     */
    public static authControllerGoogleAuth(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/auth/google',
        });
    }
    /**
     * @param requestBody Change Password Request Body
     * @returns any Password change success response
     * @throws ApiError
     */
    public static authControllerChangePassword(
        requestBody: {
            email: string;
            oldPassword: string;
            newPassword: string;
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v0/api/change-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param formData Edit user info request
     * @returns any Edit user info response
     * @throws ApiError
     */
    public static authControllerChangeUserInfo(
        id: string,
        formData: {
            name?: string;
            profileImage?: Blob;
        },
    ): CancelablePromise<{
        name: string;
        email: string;
        phone: string;
        isVerified?: boolean;
        profileImageUrl: string;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v0/api/change-user-info',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param requestBody Forgot password
     * @returns ForgotPasswordResponse Forgot password response
     * @throws ApiError
     */
    public static authControllerForgotPassword(
        requestBody?: ForgotPasswordRequest,
    ): CancelablePromise<ForgotPasswordResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v0/api/forgot-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody Login request body
     * @returns any Login response
     * @throws ApiError
     */
    public static authControllerLogin(
        requestBody: LoginRequest,
    ): CancelablePromise<{
        token?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v0/api/login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns MyAccountResponse My Account response
     * @throws ApiError
     */
    public static authControllerGetMyProfile(): CancelablePromise<MyAccountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/my-profile',
        });
    }
    /**
     * @param requestBody Reset password
     * @returns ResetPasswordResponse Reset password response
     * @throws ApiError
     */
    public static authControllerResetPassword(
        requestBody?: ResetPasswordRequest,
    ): CancelablePromise<ResetPasswordResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v0/api/reset-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param token
     * @returns any Return value of AuthController.verifyEmail
     * @throws ApiError
     */
    public static authControllerVerifyEmail(
        token: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/verify',
            query: {
                'token': token,
            },
        });
    }
}
